import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import classnames from 'classnames';

var Image = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Image, _React$Component);

  function Image(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = Image.prototype;

  _proto.onImageLoad = function onImageLoad() {// Could fade in here
  };

  _proto.render = function render() {
    var className = classnames('image', 'img-fluid', this.props.rounded && 'rounded-circle', this.props.className);
    var newProps = Object.assign({}, this.props, {
      className: className
    });
    return /*#__PURE__*/React.createElement("img", Object.assign({
      onLoad: this.onImageLoad,
      alt: ""
    }, newProps));
  };

  return Image;
}(React.Component);

export default Image;